/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { organisations_AbsenceDueDaysResponse } from './organisations_AbsenceDueDaysResponse';
export type organisations_AbsenceSettingsResponse = {
    /**
     * Certificate due day per report type
     */
    certificateDueDay: organisations_AbsenceDueDaysResponse;
    /**
     * UPLOAD (the employee uploads the certificate) or EAU (the office retrieves the electronic certificate)
     */
    certificateMode: organisations_AbsenceSettingsResponse.certificateMode;
    /**
     * Months a certificate is kept after the last day of the absence
     */
    certificateRetentionMonths: number;
};
export namespace organisations_AbsenceSettingsResponse {
    /**
     * UPLOAD (the employee uploads the certificate) or EAU (the office retrieves the electronic certificate)
     */
    export enum certificateMode {
        UPLOAD = 'UPLOAD',
        EAU = 'EAU',
    }
}

